export default __webpack_public_path__ + "static/media/Flag_of_Sri_Lanka.36c13abe.svg";